module.exports = __webpack_public_path__ + "img/edge_restauration_restaurant.c0707595.svg";